import { DOCUMENT_SERVICE_URL } from 'shared/constant';

export const getPropertyImage = (propertyId: string, size: number = 200) => {
    return `${DOCUMENT_SERVICE_URL}/public/documents/property-main-pictures/${propertyId}/_download/jpg/${size}`;
};
